import { render, staticRenderFns } from "./shareholders.vue?vue&type=template&id=2acbdb6a&scoped=true&"
import script from "./shareholders.vue?vue&type=script&lang=js&"
export * from "./shareholders.vue?vue&type=script&lang=js&"
import style0 from "./shareholders.vue?vue&type=style&index=0&id=2acbdb6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acbdb6a",
  null
  
)

export default component.exports